import React from 'react';

const SyncIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.84814 6.68421C3.92309 4.12632 5.90372 1 10.8553 1C15.7597 1 19.7681 5.02632 19.7681 10"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M1.84814 1.94727V6.68411H6.56393"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M19.7681 13.3158C17.6932 15.7789 15.7126 19 10.761 19C5.80941 19 1.84814 14.9737 1.84814 10.0474V10"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M19.768 18.0528V13.3159H15.0522"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default SyncIcon;
